// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CancelEmployeeDeductionResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/cancel_employee_deduction
 * Returns canceled deduction status
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_CancelEmployeeDeductionResponseDados {
id: number
status: number
status_label: string
}

export type Payroll_CancelEmployeeDeductionResponse = ApiResponse<Payroll_CancelEmployeeDeductionResponseDados>;

registerResponseContract('Payroll_CancelEmployeeDeductionResponse', {
  id:           { type: 'number',  required: true },
  status:       { type: 'number',  required: true },
  status_label: { type: 'string',  required: true },
})
